import styled from 'styled-components';
import { styledHeadingLink } from './StyledHeadingLink';
import { StyledCTARouterLink } from './StyledCTARouterLink';

export const StyledHeadingRouterLink = styled(StyledCTARouterLink)(styledHeadingLink);
